import Cesium from "cesium";

/**
 * PolylineDottedOutlineMaterial shader source
 * @returns {string}
 */
const _polylineDottedOutlineShaderSource = () => "uniform vec4 color;\n" +
  "uniform vec4 outlineColor;\n" +
  "uniform float outlineWidth;\n" +
  "uniform float dashLength;\n" +
  "uniform float dashPattern;\n" +
  "// Due to Cesium does not have int uniforms\n" +
  "uniform bool isHalf;\n" +
  "uniform bool dottedLeft;\n" +
  "\n" +
  "varying float v_polylineAngle;\n" +
  "varying float v_width;\n" +
  "\n" +
  "const float maskLength = 16.0;\n" +
  "const vec4 gapColor = vec4(0.0, 0.0, 0.0, 0.0);\n" +
  "\n" +
  "mat2 rotate(float rad) {\n" +
  "   float c = cos(rad);\n" +
  "   float s = sin(rad);\n" +
  "   return mat2(\n" +
  "       c, s,\n" +
  "       -s, c\n" +
  "   );\n" +
  "}\n" +
  "\n" +
  "czm_material czm_getMaterial(czm_materialInput materialInput)\n" +
  "{\n" +
  " czm_material material = czm_getDefaultMaterial(materialInput);\n" +
  " vec2 pos = rotate(v_polylineAngle) * gl_FragCoord.xy;\n" +
  " // Get the relative position within the dash from 0 to 1\n" +
  " float dashPosition = fract(pos.x / dashLength);\n" +
  " // Figure out the mask index.\n" +
  " float maskIndex = floor(dashPosition * maskLength);\n" +
  " // Test the bit mask.\n" +
  " float maskTest = floor(dashPattern / pow(2.0, maskIndex));\n" +
  " vec4 fragColor = (mod(maskTest, 2.0) < 1.0) ? gapColor : vec4(1.0, 1.0, 1.0, 1.0);\n" +
  " vec2 st = materialInput.st;\n" +
  " if (isHalf && dottedLeft) {\n" +
  "   if (fragColor.a < 0.005 && st.t > 0.5) {   // matches 0/255 and 1/255\n" +
  "     discard;\n" +
  "   }\n" +
  " } else if (isHalf && !dottedLeft) {\n" +
  "   if (fragColor.a < 0.005 && st.t < 0.5) {   // matches 0/255 and 1/255\n" +
  "     discard;\n" +
  "   }\n" +
  " } else if (!isHalf) {\n" +
  "   if (fragColor.a < 0.005) {   // matches 0/255 and 1/255\n" +
  "     discard;\n" +
  "   }\n" +
  " }\n" +
  " float halfInteriorWidth =  0.5 * (v_width - outlineWidth) / v_width;\n" +
  " float b = step(0.5 - halfInteriorWidth, st.t);\n" +
  " b *= 1.0 - step(0.5 + halfInteriorWidth, st.t);\n" +
  " \n" +
  " // Find the distance from the closest separator (region between two colors)\n" +
  " float d1 = abs(st.t - (0.5 - halfInteriorWidth));\n" +
  " float d2 = abs(st.t - (0.5 + halfInteriorWidth));\n" +
  " float dist = min(d1, d2);\n" +
  " \n" +
  " vec4 currentColor = mix(outlineColor, color, b);\n" +
  " vec4 outColor = czm_antialias(outlineColor, color, currentColor, dist);\n" +
  " \n" +
  " //material.emission = fragColor.rgb;\n" +
  " material.diffuse = outColor.rgb;\n" +
  " material.alpha = outColor.a;\n" +
  " \n" +
  " return material;\n" +
  "}\n";

/**
 * Extend polyline with new dotted outline type
 */
const extendPolyline = function () {
  Cesium.Material.PolylineDottedOutlineType = "PolylineDottedOutline";
  Cesium.Material._materialCache.addMaterial(Cesium.Material.PolylineDottedOutlineType, {
    fabric: {
      type: Cesium.Material.PolylineDottedOutlineType,
      uniforms: {
        color: new Cesium.Color(0.0, 0.0, 0.0, 0.0),
        outlineColor: new Cesium.Color(0.0, 0.0, 1.0, 1.0),
        outlineWidth: 3.0,
        dashLength: 16.0,
        dashPattern: 255.0,
        isHalf: true,
        dottedLeft: false,
      },
      source: _polylineDottedOutlineShaderSource()
    },
    translucent: function (material) {
      var uniforms = material.uniforms;
      return (uniforms.color.alpha < 1.0) || (uniforms.outlineColor.alpha < 1.0);
    }
  });
};

export default { extendPolyline };



// WEBPACK FOOTER //
// ./src/util/markers/cesiumPolylineExtender.js